import React, { useEffect, useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import api from "../../api/api";
import dollarImage from "../../../src/assets/Signin/Dollar.svg";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import cancelledDesk from "../../../src/assets/Signin/FrontCancel.svg";
import ConfirmFrontdesk from "../../signin/popups/ConfirmFrontdesk";
import { retrive, bluesethescope } from "./svgs";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { set } from "date-fns";
import { Backdrop, CircularProgress } from "@mui/material";
import ProviderModal from "./Providermodal";
import { useDispatch, useSelector } from "react-redux";
import PurposeOfVisitModal from "./purposeofvisitmodal";
import InsurancePlansModal from "./insuranceplanmodal";
import { showToast } from "../../reduxtoolkit/toastslice";
import { calculatePatientCopay } from "../cards/patientcalculator";
import { coverageTitle, savedCoinsurancePercent, visitCoverage } from "../cards/coveragestatus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { getPracticeId, practiceFeatures } from "../../config/practice";
import {
  osaPaymentTotal,
  osaCoinsuranceAmount,
  hasVisit,
  putOsaPaymentUpdate,
} from "./osaPayments";
// The card the modal was opened on: the same row (id + patient), else the
// patient's first row, else the first card. Matching on the patient alone
// opened a patient's OTHER visit of the day when it came first in the list.
const rowIndexOf = (rows, row) => {
  const sameRow = rows.findIndex((p) => p.id === row?.id && p.patientid === row?.patientid);
  if (sameRow !== -1) return sameRow;
  const samePatient = rows.findIndex((p) => p.patientid === row?.patientid);
  return samePatient !== -1 ? samePatient : 0;
};
// The hex keys are STORED values (currentPatient.deductiblemet, and what
// handleCheckboxChange writes). They are data, not colours - the patient card
// reads the same field. This maps them to how coverage is DRAWN, borrowing the
// card's chip palette so the two agree.
const COVERAGE_OPTIONS = [
  { code: "58D68D", label: "Covered", dot: "#23734a", bg: "#e5f5eb", border: "#cde8d7", text: "#23734a" },
  { code: "F9E79F", label: "Coinsurance", dot: "#a65c1b", bg: "#fff0e1", border: "#f6dfc4", text: "#a65c1b" },
  { code: "F3082C", label: "Deductible", dot: "#6d54a2", bg: "#eeebfc", border: "#ded6f6", text: "#6d54a2" },
];
const COVERAGE_DISPLAY = COVERAGE_OPTIONS.reduce(
  (acc, o) => ({ ...acc, [o.label]: o.dot }),
  {},
);

const Paymentsmodal = ({
  closePaymentModal,

  alldata = [],
  setFetchedData,
  fetchedData,
  costEstimate = 0,
  data,
  initialTab,
}) => {
  // Starts on the clicked card (was 0: the first render fetched the first
  // card's payments, which could land after -- and replace -- the right ones).
  const [currentIndex, setCurrentIndex] = useState(() => rowIndexOf(alldata, data));
  // The internal tab values are inverted against their labels for historical
  // reasons: "payment" renders the Update tab and "update" renders the Pay tab.
  // initialTab is given in LABEL terms ("update" | "pay") so callers do not
  // have to know that. Omitted, the role rule below decides, as it always has.
  const [activeTab, setActiveTab] = useState(
    initialTab === "pay" ? "update" : "payment",
  );
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  const [showPaymentsHistory, setShowPaymentsHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [PaymentMethod, setPaymentMethod] = useState([]);
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [copay, setCopay] = useState(0.0);
  const [selfPay, setSelfPay] = useState(0.0);
  const [coinsurance, setCoinsurance] = useState(0.0);
  const [loader, setLoader] = useState(false);
  const [deductible, setDeductible] = useState(0.0);
  const [frontDesk, setFrontDesk] = useState("");
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [paymentOnAccount, setPaymentOnAccount] = useState("");
  const [ccnumber, setCcnumber] = useState("");
  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const loginUser = localStorage.getItem("user");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [getpaymentData, setGetpaymentData] = useState(null);
  const [alertmessage, setAlertMessage] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedTab, setSelectedTab] = useState("");
  const navigate = useNavigate();
  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const userConfig = useSelector((state) => state.userconfig);
  const practiseid = getPracticeId();
  // 7825: OSA's front-desk payments (see ./osaPayments.js); 9928 as before.
  const osaPayments = practiceFeatures().osaPayments;
  const[prevamount,setPrevamount]=useState('')
    const tab = useSelector((state) => state.filter.tab);
      const currentDate = useSelector((state) => state.filter.currentDate);
  let insuranceCoveredPlan = [
    "VISIT",
    "Labs",
    "Injections",
    "EKG",
    "ULTRASOUND",
    "SLEEP STUDY",
    "ECHO",
    "RPM"
  ];
  const dispatch = useDispatch();

  const currentPatient = alldata[currentIndex] || {};
  // The visit's covered plans as stored (JSON string or array), spelled the
  // way the modal lists them so they come back preselected.
  const coveredPlansOf = (row) => {
    try {
      const raw = row?.appointment_specific?.insuranceCoveredPlan;
      const list = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (!Array.isArray(list)) return [];
      return list
        .map((p) => insuranceCoveredPlan.find((x) => x.toUpperCase() === String(p).trim().toUpperCase()))
        .filter(Boolean);
    } catch {
      return [];
    }
  };
  useEffect(() => {
    // Preselect the stored plans; the modal used to open blank, so a Save
    // wiped a patient's covered plans on every same-day row.
    setSelectedPlans(coveredPlansOf(currentPatient));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPatient.appointmentid]);
  // The visit on screen and the open tab, for responses that arrive later.
  const shownApptRef = useRef();
  shownApptRef.current = currentPatient.appointmentid;
  const activeTabRef = useRef(activeTab);
  activeTabRef.current = activeTab;
  // 7825: a patient-only search card (no appointment, no date) is never sent
  // to the payment routes; say why instead.
  const noVisit = (row) => osaPayments && !hasVisit(row);
  const refuseNoVisit = () =>
    dispatch(
      showToast({
        message: "No visit on this card. Open the patient's visit to update payments.",
        severity: "error",
      }),
    );

  const {
  costEstimate: patientCostEstimate,
  finalCopayTotal,
  finalformattedTotalcopay
} = calculatePatientCopay(currentPatient);
  // The header's due chip: verified as the card's pill is (coveragestatus.js).
  const coverage = visitCoverage(currentPatient, { usesEligibility: Boolean(osaPayments) });
  const dueChip =
    Number(finalformattedTotalcopay) > 0
      ? { label: "Payment due", dot: "#17a34a", title: undefined }
      : coverage.verified
        ? { label: "No balance due", dot: "#A1A1AA", title: undefined }
        : { label: "Unverified", dot: "#C4C4CC", title: coverageTitle(coverage) };

  const handlealert = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

function formatDateTime(dateInput, timeInput) {
  if (!dateInput) return "";

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  // Format only the date part
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `${formattedDate} ${timeInput || ""}`;
}
const fetchprevamount = async () => {
  // 7825: a patient-only search card has no visit to read payments for.
  if (noVisit(currentPatient)) {
    setPrevamount([]);
    return;
  }
  try {
    // The visit on screen (was the card the modal opened on, whichever
    // patient Next/Prev showed).
    const response = await api.post(
      `/v1/${practiseid}/patient/${currentPatient.patientid}/appointment/payment-details`,
      {
        appointmentid: currentPatient.appointmentid,
        startdate: dayjs().format("YYYY-MM-DD"),
      }
    );

    if (response.status === 200) {
      const payments = response?.data;
  setPrevamount(payments)
    } else {
      setPrevamount([]);
    }
  } catch (error) {
    console.log(error);
    setPrevamount(0);
  }
};

  useEffect(() => {
    setCurrentIndex(rowIndexOf(alldata, data));
  }, [alldata, data]);
  useEffect(() => {
    fetchFrontDesk();
    handleGetPayment({ data: currentPatient });
    fetchprevamount()
  }, [currentPatient]);
  useEffect(() => {
    if (osaPayments) {
      // OSA: copay + self pay + balance + deductible + coinsurance dollars.
      setTotalAmount(osaPaymentTotal({ copay, selfPay, paymentOnAccount, deductible, coinsurance }));
      return;
    }
    const initialTotal =
      (parseFloat(copay) || 0) +
      (parseFloat(selfPay) || 0) +
      (parseFloat(paymentOnAccount) || 0);
    let totalAfter = initialTotal;
    if (coinsurance) {
      totalAfter -= parseFloat(deductible) || 0;
      setDeductible(0);
    }
    // Round to cents — raw float addition showed 0.30000000000000004.
    setTotalAmount((Math.round(totalAfter * 100) / 100).toString());
  }, [copay, selfPay, paymentOnAccount, deductible, coinsurance]);
  useEffect(() => {
    // A caller that asked for a specific tab wins; otherwise the opening tab
    // follows the user's role, as before. This effect runs after mount, so
    // without the guard it would overwrite the requested tab.
    if (initialTab) return;
    if (userConfig?.grole == 2 || userConfig?.grole == 3) {
      setActiveTab("update"); // Pay tab
    } else {
      setActiveTab("payment"); // Update tab
    }
  }, [userConfig, initialTab]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get(
        `/v1/${practiseid}/payments/payment-methods`,
      );

      setPaymentMethod(response.status === 200 ? response.data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUpdateFrontDesk = async ({ frontDesk, data }) => {
    if (noVisit(data)) return refuseNoVisit();
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/front_desk`,
        {
          appointmentid: data.appointmentid,
          is_front_desk: frontDesk,
        },
      );
      fetchFrontDesk();
    } catch (error) {
      console.error("Error updating front desk:", error);
    }
  };
  // No amounts for the visit on screen: empty the Update form rather than
  // keep the previous visit's numbers (the Pay tab's own entries stay).
  const clearVisitAmounts = () => {
    setGetpaymentData(null);
    if (activeTabRef.current !== "payment") return;
    setCopay(0.0);
    setSelfPay(0.0);
    setDeductible(0.0);
    setPaymentOnAccount(0.0);
    setCoinsurance(0.0);
  };
  const handleGetPayment = async ({ data }) => {
    // 7825: a patient-only search card has no visit (view-payments would 400).
    if (noVisit(data)) {
      clearVisitAmounts();
      return;
    }
    setLoader(true)
    const dateString = data.startdate;
    const formattedDate = new Date(dateString).toLocaleDateString("en-CA");
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/view-payments`,
        {
          appointmentid: data.appointmentid,
          startdate: formattedDate,
        },
      );
      // Only for the visit still on screen: a late answer for a card the user
      // has left (Next/Prev) is dropped, as is a row for another appointment.
      if (String(data?.appointmentid) !== String(shownApptRef.current)) return;
      const row = response.data;
      if (
        response.status === 200 &&
        (row?.appointmentid == null || String(row.appointmentid) === String(data.appointmentid))
      ) {
        setGetpaymentData(row);
      } else {
        clearVisitAmounts();
      }
    } catch (error) {
      console.error("Error fetching payment:", error);
      if (String(data?.appointmentid) === String(shownApptRef.current)) clearVisitAmounts();
    }finally{
      setLoader(false)
    }
  };
  const handleGetpreviousPayment = async ({ data }) => {
    // 7825: no "Retrieve last visit" (it overwrites today's copay, balance,
    // self pay and coinsurance with the last visit's).
    if (osaPayments) return;
    setLoader(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/${data?.patientid}/update-deductible`,
      );

      if (response.status == 200) {
        setAlertMessage("Payments retrieved successfully");
        setSeverity("success");
        setOpen(true);
        handleGetPayment({ data: data });
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching payment:", error);
      setAlertMessage("something went wrong");
      setSeverity("error");
      setOpen(true);
    } finally {
      setLoader(false);
    }
  };
  const fetchFrontDesk = async () => {
    if (noVisit(currentPatient)) return;
    try {
      // The visit on screen (was the opened card's appointment with the
      // shown patient's id after Next/Prev).
      const response = await api.post(
        `/v1/${practiseid}/appointments/patient/${currentPatient?.patientid}/get_front_desk`,
        {
          appointmentid: currentPatient?.appointmentid,
        },
      );
      if (response.status === 200) {
        setFrontDesk(response?.is_front_desk || "");
      }
    } catch (error) {
      console.error("Error fetching front desk:", error);
    }
  };
  const hanldeFrontdeskModal = () => {
    setfrontdeskModal(true);
  };
  const handleFrontDeskToggle = () => {
    const newStatus = frontDesk === "Y" ? "N" : "Y";
    setFrontDesk(newStatus);
    fetchUpdateFrontDesk({ frontDesk: newStatus, data: currentPatient });
    // is_front_desk

        setFetchedData((prevData) =>
            prevData.map((item) =>
              item.id === data?.id ? { ...item,is_front_desk:newStatus } : item
            )
          );
  };

  useEffect(() => {
    fetchData();
    
  }, []);

  const handleCcnumberChange = (e) => setCcnumber(e.target.value);

  const handlePaymentMethodChange = (e) => {
    const selectedId = e.target.value;
    const selectedMethod = PaymentMethod.find(
      (payment) => payment.id === parseInt(selectedId),
    );
    setSelectedPaymentMethod(selectedMethod);
    setCcnumber("");
  };
  useEffect(() => {
    if (getpaymentData && activeTab === "payment") {
      setCopay(getpaymentData.copay || 0.0);
      setSelfPay(getpaymentData.selfpay || 0.0);
      setDeductible(getpaymentData.deductibleamt || 0.0);
      setPaymentOnAccount(getpaymentData.acctbalance || 0.0);
      // 7825: the visit's coinsurance dollars (percentage.Amount).
      if (osaPayments) setCoinsurance(osaCoinsuranceAmount(currentPatient));
      // 9928: the % saved on a Coinsurance visit, so reopening shows it and a
      // later Save (e.g. a copay change) does not send 0 and wipe it.
      else setCoinsurance(savedCoinsurancePercent(getpaymentData) ?? "");
    } else if (activeTab === "update") {
      setCopay("");
      setSelfPay("");
      setPaymentOnAccount("");
      setCoinsurance("");
      setDeductible("");
      setTotalAmount("0");
    }
  }, [activeTab, getpaymentData]);
  const handlePaySubmit = async () => {
    if (noVisit(currentPatient)) return refuseNoVisit();

      // Check if the payment method is selected
  if (!selectedPaymentMethod?.id) {
    dispatch(
      showToast({
        message: "Please select a payment method.",
        severity: "error",
      })
    );
    return;
  }

  if (selectedPaymentMethod.method === "CHECK" && ccnumber === '') {
  dispatch(
    showToast({
      message: "Please enter check number.",
      severity: "error",
    })
  );
  return;
} else if (selectedPaymentMethod.method !== "CASH") {
  // Only check if ccnumber is not empty and matches the format for non-CASH methods
  if (!ccnumber || !/^\d{4}$/.test(ccnumber)) {
    dispatch(
      showToast({
        message: "Please enter the last 4 digits of the card number.",
        severity: "error",
      })
    );
    return;
  }
}


  // Check if the amount fields have valid values (non-negative)
  const copayValue = parseFloat(copay) || 0;
  const selfPayValue = parseFloat(selfPay) || 0;
  const paymentOnAccountValue = parseFloat(paymentOnAccount) || 0;
  const totalAmountValue = parseFloat(totalAmount) || 0;
  if (copayValue < 0 || selfPayValue < 0 || paymentOnAccountValue < 0 || totalAmountValue < 0) {
    dispatch(
      showToast({
        message: "Please enter a valid amount (cannot be negative).",
        severity: "error",
      })
    );
    return;
  }
  // Validate that totalAmount is equal to the sum of copay, selfpay, and paymentonaccount
  // const expectedTotalAmount = copayValue + selfPayValue + paymentOnAccountValue;
  // if (totalAmountValue !== expectedTotalAmount) {
  //   dispatch(
  //     showToast({
  //       message: "Total Amount should match the sum of Co-pay, Self Pay, and Payment on Account.",
  //       severity: "error",
  //     })
  //   );
  //   return;
  // }

  if (totalAmountValue === "" || totalAmountValue <= 0) {
    dispatch(
      showToast({
        message: "Please enter a valid amount.",
        severity: "error",
      })
    );
    return;
  }

    const payload = {
      department_id: 1,
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: totalAmount,
      paymentmethodid: selectedPaymentMethod?.id,
      paymentmethod: selectedPaymentMethod?.type,
      ccnumber: ccnumber,
      paymentstatus: "success",
      paymentlocation: "Practice App",
      paymenttype: selectedPaymentMethod?.type,
      // copay: copay||0,
      // paymentonaccount: paymentOnAccount||0,
      insurance: currentPatient.insurancename,
      // selfpay: selfPay,
      createdby: loginUser,
    };
    if (selfPay) {
      payload.selfpay = selfPay;
    }
    if (copay) {
      payload.copay = copay;
    }
    if (paymentOnAccount) {
      payload.paymentonaccount = paymentOnAccount;
    }
    try {
      setLoading(true);
      const response = await api.post(
        `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/take-payments`,
        payload,
      );

      if (response.status == 200) {
        //     setAlertMessage('Payment processed successfully.');
        // setSeverity("success");
        // setOpen(true);
        let payload = {
  appointmentdate: currentDate,
  searchflag: currentPatient.patientid,
  dashfilter: null,
  filterarr: [],
  start: 0,
  limit: 0,
};

const dashboarddata = await api.post(
  `/v1/${practiseid}/appointments/dashboard`,
  payload
);

setFetchedData((prevData) => {
  // Merge EVERY returned row by id - merging only data[0] silently missed
  // the visible card whenever the patient has 2+ appointments today (the
  // refetch returns all of them and [0] can be the other one), so the
  // updated copay only appeared after a full page refresh (QA 2026-08-27).
  if (
    dashboarddata?.status === 200 &&
    dashboarddata?.data?.length > 0
  ) {
    const byId = new Map(dashboarddata.data.map((r) => [r.id, r]));
    let matched = false;
    const next = prevData.map((item) => {
      if (byId.has(item.id)) {
        matched = true;
        return { ...item, ...byId.get(item.id) };
      }
      return item;
    });
    if (matched) return next;
  }

  // ❌ If condition fails → fallback to your original logic
  return prevData.map((item) =>
    item.id === data.id
      ? {
          ...item,
          copay: copay || 0,
          acctbalance: paymentOnAccount || 0,
        }
      : item
  );
});

        dispatch(
          showToast({
            message: "Payment processed successfully",
            severity: "success",
          }),
        );
        closePaymentModal();
        //     setTimeout(() => {

        // }, 1200);
      } else {
        //        setAlertMessage(response.message);
        // setSeverity("info");
        // setOpen(true);
        dispatch(
          showToast({
            message: response.message,
            severity: "info",
          }),
        );
      }

      // if (response.status !== 200) {
      //   setTimeout(() => navigate('/landing'), 1000);
      // }
    } catch (error) {
      console.error("Error submitting payment:", error);
      dispatch(
        showToast({
          message: "Something went wrong",
          severity: "error", // or "info" if you prefer
        }),
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const colorTabMap = {
      "58D68D": "Covered",
      F9E79F: "Coinsurance",
      F3082C: "Deductible",
    };

    const color = currentPatient?.deductiblemet;

    if (colorTabMap[color]) {
      setSelectedColor(color);
      setSelectedTab(colorTabMap[color]);
    } else {
      setSelectedColor("");
      setSelectedTab("");
    }
  }, [currentPatient]);
  // 9928: the % only belongs to the Coinsurance pick. Leaving it (Covered /
  // Deductible) empties a loaded or typed % so it is not kept hidden (a
  // non-empty % zeroes the deductible in the total effect above).
  useEffect(() => {
    if (osaPayments) return;
    if (selectedTab !== "Coinsurance") setCoinsurance((c) => (c ? "" : c));
  }, [selectedTab]);
  const handleUpdatePay = async () => {
    // 7825: never send a patient-only search card (no visit, no date): OSA's
    // build sent searchdate "Invalid Date" and got 400 every time.
    if (noVisit(currentPatient)) return refuseNoVisit();
    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );
    const payload = {
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      location: "Practice App",
      insurance: currentPatient.insurancename,
      copay: copay || 0.0,
      accountbalance: paymentOnAccount || 0.0,
      deductibleamt: deductible || 0.0,
      coinsurancepercent: coinsurance || 0.0,
      selfpaybalance: selfPay || 0.0,
      amount: totalAmount || 0.0,
      searchdate: formattedStartDate,
      createdby: loginUser,
    };
    setLoading(true);
    try {
      // 7825: OSA's v1-only update-patient-payments (coinsurance in dollars).
      const response = osaPayments
        ? await putOsaPaymentUpdate(practiseid, currentPatient.patientid, payload)
        : await api.put(
        `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`,
        payload,
      );
      if (response.status == 200) {
let payload = {
  appointmentdate: currentDate,
  searchflag: currentPatient.patientid,
  dashfilter: null,
  filterarr: [],
  start: 0,
  limit: 0,
};

const dashboarddata = await api.post(
  `/v1/${practiseid}/appointments/dashboard`,
  payload
);

setFetchedData((prevData) => {
  // Check API success and valid data
  if (
    dashboarddata?.status === 200 &&
    dashboarddata?.data?.length > 0
  ) {
    const apiItem = dashboarddata.data[0];

    return prevData.map((item) =>
      item.id === apiItem.id
        ? { ...item, ...apiItem } // ✅ Replace with complete API object
        : item
    );
  }

  // ❌ If condition fails → fallback to your original logic
  return prevData.map((item) =>
    item.id === data.id
      ? {
          ...item,
          copay: copay || 0,
          acctbalance: paymentOnAccount || 0,
        }
      : item
  );
});
        // setFetchedData((prevData) =>
        //   prevData.map(
        //     (item) =>
        //       item.id === data.id
        //         ? { ...item, copay: copay || 0 ,acctbalance:paymentOnAccount||0} // update only room_no
        //         : item, // keep others unchanged
        //   ),
        // );
        dispatch(
          showToast({
            message: response.message,
            severity: "success",
          }),
        );

        closePaymentModal();
      } else {
        dispatch(
          showToast({
            message: response.message,
            severity: "info",
          }),
        );
      }

      handleGetPayment({ data: currentPatient });
    } catch (error) {
      console.error("Error submitting payment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (selectedColor) => {
    // 7825 sets no payment colours (Covered zeroes the amount due on every
    // visit the patient has that day).
    if (osaPayments) return;
    if (noVisit(currentPatient)) return refuseNoVisit();
    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );
    const payload = {
      patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: selectedColor,
      type: "dele",
      searchdate: formattedStartDate,
      createdby: loginUser,
    };
    //here if deducatble and selected  plans send key  insuranceCoveredPlan:[]
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`,
        payload,
      );
      if (response.status == 200) {
        setFetchedData((prevData) =>
          prevData.map(
            (item) =>
              item.id === data.id
                ? { ...item, deductiblemet: selectedColor } // update only room_no
                : item, // keep others unchanged
          ),
        );
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };
  const handleCheckboxChange = (color, tabName) => {
    if (osaPayments) return; // 7825: no colour options (OSA's build)
    if (tabName === "Deductible"||tabName==="Coinsurance") {
      setSelectedColor(color);
      setSelectedTab(tabName);
      setInsuranceModalOpen(true);
      return; // ❌ stop API
    }

    if (selectedColor === color) {
      setSelectedColor("");
      setSelectedTab("");
    } else {
      setSelectedColor(color);
      setSelectedTab(tabName);
    }

    handleStatus(color);
  };

  // const handleCheckboxChange = (color, tabName) => {
  //   if (selectedColor === color) {
  //     setSelectedColor('');
  //     setSelectedTab('');
  //   } else {
  //     setSelectedColor(color);
  //     setSelectedTab(tabName);
  //   }
  //   handleStatus(color);
  // };

  const handleNextPatient = () => {
    if (currentIndex < alldata.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevPatient = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // useEffect(() => {
  //   if (currentPatient) {
  //     setCopay(currentPatient.copay_amt_paid || 0);
  //     setPaymentOnAccount(currentPatient.total_amount_paid || '');
  //     setDeductible(currentPatient.deductibleamt || 0);
  //   } else {
  //     setCopay(0.0);
  //     setPaymentOnAccount('');
  //     setDeductible(0.0);
  //   }

  //   // if (activeTab === 'payment') {
  //   //   setSelfPay('');
  //   //   setPaymentOnAccount('');
  //   //   setCoinsurance('');
  //   //   setDeductible('');
  //   //   setTotalAmount('0');
  //   //   setCopay(0.0);
  //   // } else if (activeTab === 'update') {
  //   //   setSelfPay('');
  //   //   setPaymentOnAccount('');
  //   //   setCoinsurance('');
  //   //   setDeductible('');
  //   //   setTotalAmount('0');
  //   // }
  // }, [activeTab, currentPatient]);
  const handleInsuranceSave = async (plans) => {
    setInsuranceModalOpen(false);
    setSelectedPlans(plans || []);
    if (noVisit(currentPatient)) return refuseNoVisit();

    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );

    const payload = {
      patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      searchdate: formattedStartDate,
      createdby: loginUser,
    };
    // Only a picked coverage colour is written; without one the save must not
    // blank deductiblemet (the stored colour stays).
    if (selectedColor) {
      payload.amount = selectedColor;
      payload.type = "dele";
    }

    // send ONLY for deductible save
    if (Array.isArray(plans)) {
      payload.insuranceCoveredPlan = plans;
    }

    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`,
        payload,
      );

      if (response.status === 200) {
        // update deductible color
        if (selectedColor) {
          setFetchedData((prev) =>
            prev.map((item) =>
              item.id === data.id ? { ...item, deductiblemet: selectedColor } : item,
            ),
          );
        }

        // 🔥 fetch orders
        const ordersPayload = {
          patientid: data.patientid,
          orderdate: dayjs(data.startdate).format("YYYY-MM-DD"),
        };

        const ordersresponse = await api.post(
          `/v1/${practiseid}/orders/get`,
          ordersPayload,
        );

        if (ordersresponse.status === 200) {
          const apiOrders = ordersresponse.data;

          // 🔥 safe state update
          setFetchedData((prev) =>
            prev.map((patient) =>
              patient.patientid === data.patientid
                ? { ...patient, orders: apiOrders }
                : patient,
            ),
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 overflow-y-auto">
      <div className="flex justify-center min-h-screen py-10">
        <div className="bg-white p-6 rounded-2xl shadow-xl w-[92%] max-w-[550px] my-10">
          {/* Header */}
          <div className="w-full flex items-start justify-between">
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[#8A94A4]">
                Payments
              </div>
              <h2 className="text-[20px] leading-tight mt-1 text-[#18181B]">
                <span className="font-bold">Patient {currentIndex + 1}</span>{" "}
                <span className="font-normal text-[#A1A1AA]">
                  of {alldata.length}
                </span>
              </h2>
            </div>
            <ClearIcon
              onClick={() => {
                setPrevamount("");
                closePaymentModal();
              }}
              className="cursor-pointer text-[#A1A1AA]"
            />
          </div>

          {/* Patient panel, with stepping controls outside its edges */}
          <div className="flex items-center gap-2 mt-5">
            <button
              onClick={handlePrevPatient}
              disabled={currentIndex === 0}
              aria-label="Previous patient"
              className="flex-none w-9 h-9 rounded-full bg-white border border-[#E4E4E7] text-[#52525C] flex items-center justify-center hover:bg-[#F4F4F5] disabled:opacity-40"
            >
              <ChevronLeftIcon fontSize="small" />
            </button>

            <div className="flex-1 min-w-0 rounded-[14px] border border-[#EBECF0] bg-[#FAFAFB] px-4 py-4 text-center">
              <div className="flex items-center justify-center gap-2 flex-wrap">
                {currentPatient?.purpose && (
                  <button
                    type="button"
                    onClick={() => setPurposeModalOpen(true)}
                    className="rounded-full border border-[#E2E8F0] bg-white px-3 py-1 text-[11px] text-[#18181B]"
                  >
                    {currentPatient.purpose}
                  </button>
                )}
                {/* Same rule as the card's pill: before coverage is verified
                    a $0 is not known, so it is not "No balance due". */}
                <span
                  className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#E4E4E7] px-3 py-1 text-[11px] font-medium text-[#3F3F46]"
                  title={dueChip.title}
                  data-coverage={coverage.verified ? "verified" : "unverified"}
                >
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ background: dueChip.dot }}
                  />
                  {dueChip.label}
                </span>
              </div>

              <div className="mt-2 text-[18px] font-bold text-[#18181B] truncate">
                {currentPatient.firstname + " " + currentPatient.lastname}
                <span className="ml-2 text-[13px] font-normal text-[#A1A1AA]">
                  #{currentPatient.patientid}
                </span>
              </div>

              <div className="mt-1 text-[12px] text-[#71717A]">
                {formatDateTime(
                  getpaymentData?.startdate,
                  currentPatient?.start_time,
                )}
                {currentPatient?.visit_confirmation
                  ? ` · ${currentPatient.visit_confirmation}`
                  : ""}
              </div>

              <div className="mt-1 flex items-center justify-center gap-1.5 text-[12px] text-[#71717A]">
                <span className="inline-flex items-center">
                  {bluesethescope}
                </span>
                <button
                  type="button"
                  onClick={() => {
                    if (homescreenprev.includes("Change Provider")) {
                      setProviderModalOpen(true);
                    }
                  }}
                  className="font-semibold text-[#164580]"
                >
                  {currentPatient?.linked_provider || "-"}
                </button>
                {currentPatient?.insurancename && (
                  <>
                    <span className="text-[#C4C4CC]">·</span>
                    <span className="truncate">
                      {currentPatient.insurancename}
                    </span>
                  </>
                )}
              </div>
            </div>

            <button
              onClick={handleNextPatient}
              disabled={currentIndex === alldata.length - 1}
              aria-label="Next patient"
              className="flex-none w-9 h-9 rounded-full bg-white border border-[#E4E4E7] text-[#52525C] flex items-center justify-center hover:bg-[#F4F4F5] disabled:opacity-40"
            >
              <ChevronRightIcon fontSize="small" />
            </button>
          </div>

          {/* Update / Pay */}
          <div className="flex bg-[#F4F4F5] rounded-[10px] p-1 gap-1 mt-5">
            <button
              className={`py-2 px-4 text-[14px] font-inter outline-none w-full text-center rounded-[8px] ${
                activeTab === "payment"
                  ? "bg-white text-[#18181B] font-medium shadow-sm"
                  : "text-[#8A94A4]"
              }`}
              onClick={() => setActiveTab("payment")}
            >
              Update
            </button>
            <button
              className={`py-2 px-4 text-[14px] font-font1 outline-none w-full text-center rounded-[8px] ${
                activeTab === "update"
                  ? "bg-white text-[#18181B] font-medium shadow-sm"
                  : "text-[#8A94A4]"
              }`}
              onClick={() => setActiveTab("update")}
            >
              Pay
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-4">
            {/* Payment Tab Content */}
            {activeTab === "payment" && (
              <div>
                {/* Coverage */}
                <div className="flex items-center gap-2 flex-wrap">
                  {!osaPayments && (
                  <span className="text-[11px] font-semibold uppercase tracking-[0.1em] text-[#8A94A4] mr-1">
                    Coverage
                  </span>
                  )}
                  <div
                    className="cursor-pointer flex items-center"
                    onClick={hanldeFrontdeskModal}
                    title="Front desk"
                  >
                    {frontDesk === "N" ? (
                      <PersonalVideoIcon fontSize="small" />
                    ) : (
                      <img src={cancelledDesk} alt="$" className="w-5" />
                    )}
                  </div>
                  {!osaPayments && (
                  <>
                  {COVERAGE_OPTIONS.map((opt) => {
                    const on = selectedColor === opt.code;
                    return (
                      <button
                        key={opt.code}
                        type="button"
                        onClick={() =>
                          handleCheckboxChange(opt.code, opt.label)
                        }
                        className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[12px] font-medium transition"
                        style={
                          on
                            ? {
                                background: opt.bg,
                                borderColor: opt.border,
                                color: opt.text,
                              }
                            : {
                                background: "#F4F4F5",
                                borderColor: "#E4E4E7",
                                color: "#8A94A4",
                              }
                        }
                      >
                        <span
                          className="w-1.5 h-1.5 rounded-full"
                          style={{ background: on ? opt.dot : "#C4C4CC" }}
                        />
                        {opt.label}
                      </button>
                    );
                  })}
                  {selectedTab?.length ? (
                    <button
                      type="button"
                      aria-label="Clear coverage"
                      onClick={() => handleCheckboxChange("0", "")}
                      className="text-[#A1A1AA]"
                    >
                      <CloseIcon fontSize="small" />
                    </button>
                  ) : null}
                  </>
                  )}
                </div>

                {/* Amounts */}
                <div className="grid grid-cols-1 gap-3 mt-4">
                  <div className="flex gap-4 justify-between items-center">
                    <label className="flex items-center gap-2 text-sm font-semibold font-inter text-[#18181B]">
                      <span
                        className="w-2 h-2 rounded-full"
                        style={{ background: COVERAGE_DISPLAY.Covered }}
                      />
                      Co-pay
                    </label>
                    <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={copay}
                        onChange={(e) => setCopay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter text-[#18181B]">
                      Balance
                    </label>
                    <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={paymentOnAccount}
                        onChange={(e) => setPaymentOnAccount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4 justify-between items-center">
                    <label className="flex items-center gap-2 text-sm font-semibold font-inter text-[#18181B]">
                      <span
                        className="w-2 h-2 rounded-full"
                        style={{ background: COVERAGE_DISPLAY.Deductible }}
                      />
                      Deductible
                    </label>
                    <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={deductible}
                        onChange={(e) => setDeductible(e.target.value)}
                        type="number"
                        disabled={
                           // 7825 (OSA): editable whatever the visit status.
                           !osaPayments && !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
                        }
                        className={`w-full border-none outline-none px-1 ${
                           !osaPayments && !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
                            ? "cursor-not-allowed"
                            : ""
                        }`}
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter text-[#18181B]">
                      Self Pay
                    </label>
                    <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={selfPay}
                        onChange={(e) => setSelfPay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  {osaPayments && (
                    // 7825 (OSA): coinsurance in dollars, always shown, in the total.
                    <div className="flex gap-4 justify-between items-center">
                      <label className="block text-sm font-semibold font-inter text-[#18181B]">
                        Co-Insurance
                      </label>
                      <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                        <span className="text-sm">
                          <img src={dollarImage} alt="%$" />
                        </span>
                        <input
                          value={coinsurance}
                          onChange={(e) => setCoinsurance(e.target.value)}
                          type="number"
                          className="w-full border-none outline-none px-1"
                          placeholder=""
                          aria-label="Co-Insurance"
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                    </div>
                  )}

                  {!osaPayments && selectedTab === "Coinsurance" && (
                    <div>
                      <div className="flex gap-4 justify-between items-center">
                        <label className="flex items-center gap-2 text-sm font-semibold font-inter text-[#18181B]">
                          <span
                            className="w-2 h-2 rounded-full"
                            style={{ background: COVERAGE_DISPLAY.Coinsurance }}
                          />
                          Co-Insurance
                        </label>
                        <div className="flex items-center w-[70%] border border-[#E4E4E7] rounded-lg px-2 py-1.5 focus-within:border-[#3B82F6]">
                          <input
                            value={coinsurance}
                            onChange={(e) => setCoinsurance(e.target.value)}
                            type="number"
                            className="w-full border-none outline-none px-1"
                            placeholder=""
                          />
                          <span className="text-md font-inter text-gray-500">
                            %
                          </span>
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <p className="w-[70%] mt-1 text-[11px] leading-snug text-[#8A94A4]">
                          Applied to the claim once insurance processes it — not
                          added to the total.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Total */}
                  <div className="pt-3 mt-1 border-t border-[#EBECF0] flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter text-[#18181B]">
                      Total
                    </label>
                    <div className="flex items-center w-[70%] bg-[#F4F4F5] border border-[#EBECF0] rounded-lg px-2 py-1.5">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        type="number"
                        className="w-full bg-transparent border-none outline-none px-1 font-semibold text-[#18181B]"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>

                {/* Secondary actions */}
                <div className={osaPayments ? "grid grid-cols-1 gap-3 mt-4" : "grid grid-cols-2 gap-3 mt-4"}>
                  {!osaPayments && (
                  <button
                    type="button"
                    onClick={() => {
                      handleGetpreviousPayment({ data: currentPatient });
                    }}
                    className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-[10px] bg-white border border-[#E4E4E7] text-[13px] text-[#18181B] hover:bg-[#FAFAFB]"
                  >
                    {retrive}
                    <span>Retrieve last visit</span>
                  </button>
                  )}
                  {/* The note is the covered-plans save (handleInsuranceSave:
                      payment/update with the coverage colour). 7825 has no
                      payment colours, so no note; elsewhere it waits for a
                      colour like the Deductible / Coinsurance chips that
                      open the same modal. */}
                  {!osaPayments && (
                  <button
                    type="button"
                    disabled={!selectedColor}
                    title={selectedColor ? undefined : "Pick a coverage status first"}
                    onClick={() => setInsuranceModalOpen(true)}
                    className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-[10px] bg-white border border-[#E4E4E7] text-[13px] text-[#18181B] hover:bg-[#FAFAFB] disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <DescriptionOutlinedIcon fontSize="small" />
                    <span>Add insurance note</span>
                  </button>
                  )}
                </div>

                {/* Last payment */}
                {Array.isArray(prevamount) && prevamount.length > 0 && (
                  <div className="mt-4 flex items-center gap-3 rounded-[12px] bg-[#FAFAFB] border border-[#EBECF0] px-3 py-3">
                    <span className="flex-none w-8 h-8 rounded-full bg-white border border-[#E4E4E7] flex items-center justify-center">
                      <img src={dollarImage} alt="$" />
                    </span>
                    <div className="min-w-0">
                      <div className="text-[11px] text-[#8A94A4]">
                        Last payment
                      </div>
                      <div className="text-[13px] text-[#18181B] truncate">
                        ${prevamount[0].amount} on{" "}
                        {new Date(
                          prevamount[0].payment_date,
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })}
                        {prevamount[0].method
                          ? ` · ${prevamount[0].method}`
                          : ""}
                      </div>
                    </div>
                    {prevamount.length > 1 && (
                      <FontAwesomeIcon
                        icon={faEye}
                        className="ml-auto text-[#8A94A4] cursor-pointer"
                        onClick={() => setShowPaymentsHistory(true)}
                      />
                    )}
                  </div>
                )}

                {/* Footer */}
                <div className="mt-4 pt-4 border-t border-[#EBECF0] flex items-end justify-between gap-4">
                  <div className="text-[11px] leading-snug text-[#8A94A4] min-w-0">
                    <div className="truncate">
                      Insurance: {data?.insurancename}
                    </div>
                    {currentPatient?.patientid === data?.patientid &&
                      costEstimate > 0 && (
                        <div className="truncate">
                          Cost estimate: ${costEstimate}
                        </div>
                      )}
                  </div>
                  <button
                    onClick={() => handleUpdatePay(data)}
                    disabled={loading}
                    className="flex-none min-w-[170px] py-2.5 px-5 rounded-[10px] bg-[#18181B] text-white text-[14px] font-medium flex items-center justify-center disabled:bg-[#E4E4E7] disabled:text-[#A1A1AA]"
                  >
                    {loading ? (
                      <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                    ) : (
                      "Update payment"
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Update Tab Content */}
            {activeTab === "update" && (
              <div>
  {Array.isArray(prevamount) && prevamount.length > 0 ? (
    <div className="flex justify-center items-center ">


  <div className="text-center flex items-center font-bold text-[#71717A]">
    Amount Paid: ${prevamount[0].amount} on{" "}
    {new Date(prevamount[0].payment_date).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })}
{prevamount.length > 1 && (
  <FontAwesomeIcon
    icon={faEye}
    className="ml-2 text-[#71717A] cursor-pointer"
    onClick={() => setShowPaymentsHistory(true)}
  />
)}
  </div>

    </div>

) : null}
                <div className="text-[17px] font-inter mb-1 text-left">
                  Payment method
                </div>
                <div className="flex gap-4 justify-between flex-col items-center mt-2 mb-2">
                  <select
                    onChange={handlePaymentMethodChange}
                    className="border rounded-lg px-2 py-2 w-[100%]"
                  >
                    <option value="">Select Payment method</option>
                    {loading ? (
                      <option disabled>Loading...</option>
                    ) : (
                      PaymentMethod.map((payment) => (
                        <option key={payment.id} value={payment.id}>
                          {payment.method}
                        </option>
                      ))
                    )}
                  </select>
                  {selectedPaymentMethod &&
                    !(selectedPaymentMethod.method === "CASH") && (
                      <div className="w-full">
                        <label className="block mb-1 my-0 text-left">
                          {" "}
                          {selectedPaymentMethod.method === "CHECK"
                            ? "Check Number"
                            : "Enter 4-digit number"}
                        </label>
                        <input
                          type="text"
                          value={ccnumber}
                          // onChange={(e) => setCcnumber(e.target.value)}
                          onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setCcnumber(value);
                              }
                            }}
                          maxLength={selectedPaymentMethod.method === "CHECK" ? 15 : 4}   
                          pattern={selectedPaymentMethod.method === "CHECK" ? "[0-9]+" : "[0-9]{4}"}
                          placeholder={selectedPaymentMethod.method === "CHECK" ? "Check number" : "4 digits"}
                          // maxLength="4"
                          // pattern="[0-9]{4}"
                          // placeholder="4 digits"
                          className="border rounded-lg px-2 py-1  w-[100%]"
                        />
                      </div>
                    )}
                </div>

                <p className="text-[16px]  font-semibold mb-2 text-left">
                  Payment Type
                </p>
                <div className="grid grid-cols-1 gap-4 mt-1">
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Co-pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={copay}
                        onChange={(e) => setCopay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Self Pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={selfPay}
                        onChange={(e) => setSelfPay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1 w-[80px] text-left">
                      Payment on Account
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={paymentOnAccount}
                        onChange={(e) => setPaymentOnAccount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Total Amount
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex justify-start mt-3">
                  {/* <div             onClick={()=>{handleGetpreviousPayment({data:currentPatient})}}
className="inline-flex items-center gap-2 cursor-pointer px-4 py-2 rounded-[22px] bg-white shadow-[0_0_4px_rgba(0,0,0,0.25)]">
  {retrive}
  <span>Retrieve last visit</span>
</div> */}
                </div>

                <div className="mt-4 flex flex-column gap-2 text-left">
                  <div className="text-sm font-semibold text-[#71717A] mt-1">
                    {data.insurancename}
                  </div>

                  <button
                    onClick={() => handlePaySubmit(data)}
                    disabled={loading}
                    className="w-full py-2 bg-black text-white rounded-lg flex items-center justify-center"
                  >
                    {loading ? (
                      <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                    ) : (
                      "Pay"
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
          {providerModalOpen && (
            <ProviderModal
              open={providerModalOpen}
              current={currentPatient?.linked_provider}
              onClose={() => setProviderModalOpen(false)}
              selectedCard={currentPatient}
              setFetchedData={setFetchedData}
              setProviderModalOpen={setProviderModalOpen}
            />
          )}
          {frontdeskModal && (
            <ConfirmFrontdesk
              frontDesk={frontDesk}
              handleFrontDeskToggle={handleFrontDeskToggle}
              setfrontdeskModal={setfrontdeskModal}
            />
          )}
          <InsurancePlansModal
            open={insuranceModalOpen}
            preSelected={selectedPlans}
            onClose={() => setInsuranceModalOpen(false)}
            onSave={handleInsuranceSave}
          />

          <ToastMessage
            message={alertmessage}
            severity={severity}
            open={open}
            handleClose={handlealert}
          />
          {purposeModalOpen && (
            <PurposeOfVisitModal
              open={purposeModalOpen}
              setFetchedData={setFetchedData}
              setPurposeModalOpen={setPurposeModalOpen}
              onClose={() => setPurposeModalOpen(false)}
              selectedCard={data}
            />
          )}
          {/* Backdrop Loader */}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
  {showPaymentsHistory && (
  <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 p-3 sm:p-4">
    
    <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">

      {/* Header */}
      <div className="flex justify-between items-center border-b px-3 py-2 sm:px-4 sm:py-3">
        <h3 className="font-semibold text-base sm:text-lg">
          Payment History
        </h3>
        <CloseIcon
          className="cursor-pointer text-gray-600"
          onClick={() => setShowPaymentsHistory(false)}
        />
      </div>

      {/* Payments list */}
      <div className="overflow-y-auto px-3 py-2 sm:px-4 sm:py-3 space-y-2 flex-1">

        {prevamount.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center border rounded-md px-2 py-2 sm:px-3"
          >
            <div className="text-xs sm:text-sm text-gray-600">
              {new Date(item.payment_date).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
            </div>

            <div className="font-semibold text-sm sm:text-base text-gray-800">
              ${item.amount}
            </div>
          </div>
        ))}

      </div>

    </div>
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default Paymentsmodal;
